<div class="pnl-settings-drive-thru">
  <header>
    <a [routerLink]="['/app/configuracao']" class="back">Configurações</a>
    <h1>Drive thru</h1>
  </header>

  <form [formGroup]="settingsFrm" (ngSubmit)="onSubmit()" novalidate>
    <section>
      <div class="status">
        <strong>Serviço de drive thru</strong>
        <span>
          Permite disponibilizar aos clientes um serviço de drive thru dos pedidos realizados na loja online
        </span>
        <div class="ipt-switch">
            <input [id]="status" formControlName="status" (change)="onChangeDetail()" name="status" type="checkbox" value="S">
            <label [for]="status"></label>
        </div>
      </div>

      <div *ngIf="status.value" class="drivethru-rules" [class.drivethru-rules-pb]="select_drivethru_type.value == '2'">
        <strong>Regras do Drive thru</strong>
        <div class="options">
          <mat-radio-group formControlName="select_drivethru_type">
            <mat-radio-button name="select_drivethru_type" value="1">Sem taxa de separacão, 100% grátis</mat-radio-button>
            <mat-radio-button name="select_drivethru_type" value="2">Taxar a separação</mat-radio-button>
          </mat-radio-group>
        </div>

        <div *ngIf="select_drivethru_type.value == '2'" class="value">
          <label>Valor da taxa de separação</label>
          <div class="prefx">
            <span class="valor">R$</span>
            <input type="text" class="form-control" formControlName="taxa_entrega_local" currencyMask (keyup)="onChangeDetail()" />
          </div>
        </div>

        <div *ngIf="select_drivethru_type.value == '2'" class="free" [class.active]="ck_free.value">
          <mat-checkbox formControlName="ck_free" class="example-margin">Conceder taxa de seperação grátis para pedidos com o valor do checkout a partir de</mat-checkbox>
          <div class="prefx">
            <span class="valor">R$</span><input type="text" class="form-control" formControlName="entrega_local_gratis" currencyMask (keyup)="onChangeDetail()" [attr.disabled]="!ck_free.value ? '' : null" />
          </div>
        </div>
      </div>

      <div *ngIf="status.value" class="drivethru-rules-options">
        <strong>Agendamento</strong>
        <span>Configure o funcionamento do agendamento:</span>

        <div class="form-col">
          <mat-checkbox formControlName="ck_drivethru" (change)="onChangeDetail()" class="example-margin">Ativar agendamento de entregas</mat-checkbox>
        </div>

        <div  *ngIf="ck_drivethru.value" class="form-col">
          <label>Intervalo de entregas em minutos:</label>
          <div class="row">
            <input type="text" class="form-control w180" formControlName="intervalo_entrega_drivethru" currencyMask [options]="{ precision: 0, allowNegative: false }" (keyup)="onChangeDetail()" />
          </div>
        </div>

        <div  *ngIf="ck_drivethru.value" class="form-col">
          <label>Quantidade de entregas por intervalo:</label>
          <div class="row">
            <input type="text" class="form-control w180" formControlName="num_entrega_drivethru" currencyMask [options]="{ precision: 0, allowNegative: false }" (keyup)="onChangeDetail()" />
          </div>
        </div>

        <div  *ngIf="ck_drivethru.value" class="form-col">
          <label>Margem padrão final em minutos:</label>
          <div class="row">
            <input type="text" class="form-control w180" formControlName="tempo_liberacao_drivethru" currencyMask [options]="{ precision: 0, allowNegative: false }" (keyup)="onChangeDetail()" />
          </div>
        </div>
      </div>

      <div *ngIf="status.value && ck_drivethru.value" class="drivethru-rules-options drivethru-rules-schedule">
        <strong>Grade de horários do agendamento</strong>
        <span>Configure a grade de horários de funcionamento:</span>

        <div class="grid" formArrayName="scheduling">
          <div class="row header mt10">
            <div class="col">
              <label>Dia da semana</label>
            </div>
            <div class="col">
              <label>Hora inicial</label>
            </div>
            <div class="col">
              <label>Hora final</label>
            </div>
            <div class="col actions"></div>
          </div>
          <div class="row" *ngFor="let grp_scheduling of scheduling.controls; let i=index" [formGroupName]="i" [class.dnone]="grp_scheduling.controls.diasemana.value == -1">
            <div class="col">
              <ng-select [items]="dias_semana" (change)="onChangeDetail()" formControlName="diasemana" (clear)="onChangeDetail()" placeholder="Selecione" bindLabel="text" bindValue="value"></ng-select>
            </div>
            <div class="col">
              <input type="text" class="form-mat-input-element" matInput mask="Hh:m0" [dropSpecialCharacters]="false" placeholder="00:00" formControlName="hora_inicio" (keyup)="onChangeDetail()" />
            </div>
            <div class="col">
              <input type="text" class="form-mat-input-element" matInput mask="Hh:m0" [dropSpecialCharacters]="false" placeholder="00:00" formControlName="hora_fim" (keyup)="onChangeDetail()" />
            </div>
            <div class="col actions">
              <a (click)="onRemoveRangeHour(i)" class="btn-close-round"></a>
            </div>
          </div>
          <div class="row">
            <button (click)="onAddNewRangeHour(undefined)" type="button" class="btn btn-green-outline">
              <span>
                <i class="btn-add-round"></i> <span>Adicionar horário</span>
              </span>
            </button>
          </div>
        </div>
      </div>

      <div *ngIf="status.value" class="drivethru-rules-options drivethru-rules-works">
        <strong>Não funcionamento</strong>
        <span>
          Cadastre os dias que o serviço estará <b>indisponível</b>
        </span>

        <div class="range" formArrayName="holidays">
          <div *ngFor="let grp_holiday of holidays.controls; let i=index" [formGroupName]="i" [class.dnone]="grp_holiday.controls.tipo.value == -1">
            <div>
              <label>Data</label>
              <div class="frm-datepicker">
                  <input type="text" formControlName="dia" class="form-control" (dateInput)="onChangeDetail()" [matDatepicker]="pickerInicialDate" />
                  <mat-datepicker-toggle matSuffix [for]="pickerInicialDate"></mat-datepicker-toggle>
                  <mat-datepicker #pickerInicialDate [startAt]="startDate"></mat-datepicker>
              </div>
            </div>
            <div>
              <label>Serviço</label>
              <ng-select [items]="formas_entrega" (change)="onChangeDetail()"  (clear)="onChangeDetail()" formControlName="tipo" placeholder="Selecione" bindLabel="text" bindValue="value"></ng-select>
            </div>
            <div class="actions">
              <a (click)="onRemoveHoliday(i)" class="btn-close-round"></a>
            </div>
          </div>

          <button (click)="onAddNewHoliday(undefined)" type="button" class="btn btn-green-outline">
            <span>
              <i class="btn-add-round"></i> <span>Adicionar novo dia</span>
            </span>
          </button>
        </div>

      </div>

    </section>
  </form>

  <div class="actions" [class.dflex]="changed">
    <span>Salvar as alterações</span>
    <div>
      <button type="button" (click)="onCancel()" class="btn btn-primary-outline">Cancelar</button>
      <button type="button" (click)="onSubmit()" class="btn btn-primary">Salvar</button>
    </div>
  </div>

  <div class="loading" *ngIf="loading">
    <div class="loadingio-spinner-eclipse-cz3y1wre1nd">
        <div class="ldio-ns36390yc">
            <div></div>
        </div>
    </div>
  </div>
</div>
